import { render, staticRenderFns } from "./BankDetail.vue?vue&type=template&id=a577ea68&scoped=true&"
import script from "./BankDetail.vue?vue&type=script&lang=js&"
export * from "./BankDetail.vue?vue&type=script&lang=js&"
import style0 from "./BankDetail.vue?vue&type=style&index=0&id=a577ea68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a577ea68",
  null
  
)

export default component.exports